import React from 'react';
import { NavLink } from 'react-router-dom';

const WhatsAppButton = () => {
    return (
        <NavLink
            to="https://wa.me/447707337351"
            className="whatsapp-btn"
            target="_blank"
            rel="noopener noreferrer"
            style={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                zIndex: 1000,
                backgroundColor: '#25D366',
                color: 'white',
                borderRadius: '50%',
                width: '60px',
                height: '60px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
                fontSize: '30px',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
            }}
        >
            <i className="ri-whatsapp-line"></i>
        </NavLink>
    );
};

export default WhatsAppButton;
